<!--
  Bot picker shown in the Appbar for multi-bot users. Selecting a bot
  dispatches `bots/changeBot`, which also updates the router.

  Styled for the dark Appbar to match the SearchComponent button next to it:
  borderless translucent white, same height (h-10), and sized to its content
  rather than stretching across the bar. The height goes through
  `data-[size=default]:` because SelectTrigger's own `data-[size=default]:h-9`
  would otherwise out-rank a plain `h-10`.

  NOTE: the legacy version listened to the Vuetify 2 `@change` event, which
  Vuetify 3 no longer emits — switching bots here was silently broken. Fixed
  by using `update:model-value`.
-->
<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import SimpleSelect from '@/components/forms/select/SimpleSelect.vue';
import { useBotsStore } from '@/stores/bots';

const botsStore = useBotsStore();
const router = useRouter();

const bots = computed(() => botsStore.botsGetter);
const currentBot = computed(() => botsStore.currentBotGetter);

function changeBot(uniqueBotId: unknown) {
  if (!uniqueBotId) return;
  botsStore.changeBot({
    uniqueBotId,
    router,
  });
}
</script>

<!--
  The wrapper is what carries `class`/`data-cy` from the caller: reka's
  `SelectRoot` sets `inheritAttrs: false`, so attributes put on `SimpleSelect`
  itself are dropped instead of reaching the trigger.
-->
<template>
  <div>
    <SimpleSelect
      :items="bots"
      item-label="name"
      item-value="uniqueBotId"
      :model-value="currentBot?.uniqueBotId"
      trigger-class="data-[size=default]:h-10 w-fit max-w-[140px] cursor-pointer gap-3 border-0 bg-white/10 px-4 font-medium text-white shadow-none transition-all hover:bg-white/20 focus-visible:ring-white/40 sm:max-w-[250px] [&_svg]:text-white [&_svg]:opacity-80"
      @update:model-value="changeBot"
    />
  </div>
</template>
